module.exports = __webpack_public_path__ + "static/media/Marston Ave, San Francisco, CA1.57178717.jpg";